import React, { useState } from "react";
import { Button, ListGroup, Modal, Stack } from "react-bootstrap";
import { FileIndex } from "../types";
import { filesService } from "../services";

const AssignParentModal: React.FC<{
  showModal: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  selectedItem: FileIndex | undefined;
  fileList: FileIndex[];
  refreshFileList: () => void;
}> = ({ showModal, setShowModal, selectedItem, fileList, refreshFileList }) => {
  const [selectedFolder, setSelectedFolder] = useState<FileIndex>();
  const foldersList = fileList.filter((item) => item.fileType === "folder");

  const assignItem = async () => {
    if (selectedItem !== undefined && selectedFolder !== undefined) {
      await filesService.assignToFolder(selectedItem, selectedFolder);
      refreshFileList();
      setShowModal(false);
    }
  };
  return (
    <Modal show={showModal} onHide={() => setShowModal(false)}>
      <Modal.Header closeButton>Move to Folder</Modal.Header>
      <Modal.Body>
        <Stack gap={3}>
          <ListGroup variant="flush">
            {foldersList.map((item) => (
              <ListGroup.Item
                key={item.fileName}
                active={item.fileName === selectedFolder?.fileName}
                onClick={() => setSelectedFolder(item)}
              >
                {item.displayName}
              </ListGroup.Item>
            ))}
          </ListGroup>
          <Button
            disabled={selectedFolder === undefined}
            onClick={() => assignItem()}
          >
            Ok
          </Button>
        </Stack>
      </Modal.Body>
    </Modal>
  );
};

export default AssignParentModal;
